/*
Monotype Foundry Platform API
Version 1.0.0

Definition: Impersonation

Properties:
  additionalDetails: string
  foundryId: string, minLength: 1
  otherImpersonationReason: string
  reason: string (required), minLength: 1
*/

var Impersonation = (function () {
  function validateImpersonation (arg) {
    // Validate additionalDetails
    if (arg.additionalDetails && !(typeof arg.additionalDetails === 'string')) {
      throw new Error('Impersonation.additionalDetails: Wrong type: Got \'' + (typeof arg.additionalDetails) + '\', but expected: \'string\'')
    }
    // Validate foundryId
    if (arg.foundryId && !(typeof arg.foundryId === 'string')) {
      throw new Error('Impersonation.foundryId: Wrong type: Got \'' + (typeof arg.foundryId) + '\', but expected: \'string\'')
    }
    if (arg.foundryId && !(arg.foundryId.length >= 1)) {
      throw new Error('Impersonation.foundryId: Minimum length 1, but got: ' + arg.foundryId.length)
    }
    // Validate otherImpersonationReason
    if (arg.otherImpersonationReason && !(typeof arg.otherImpersonationReason === 'string')) {
      throw new Error('Impersonation.otherImpersonationReason: Wrong type: Got \'' + (typeof arg.otherImpersonationReason) + '\', but expected: \'string\'')
    }
    // Validate reason
    if (!arg.reason) {
      throw new Error('Impersonation.reason: Missing property')
    }
    if (arg.reason && !(typeof arg.reason === 'string')) {
      throw new Error('Impersonation.reason: Wrong type: Got \'' + (typeof arg.reason) + '\', but expected: \'string\'')
    }
    if (arg.reason && !(arg.reason.length >= 1)) {
      throw new Error('Impersonation.reason: Minimum length 1, but got: ' + arg.reason.length)
    }
  }
  function buildImpersonation (arg) {
    var Impersonation = arg
    // Complete additionalDetails
    // Expected Type: string
    Impersonation.additionalDetails = Impersonation.additionalDetails || ''
    // Complete foundryId
    // Expected Type: string
    Impersonation.foundryId = Impersonation.foundryId || ''
    // Complete otherImpersonationReason
    // Expected Type: string
    Impersonation.otherImpersonationReason = Impersonation.otherImpersonationReason || ''
    // Complete reason
    // Expected Type: string
    Impersonation.reason = Impersonation.reason || ''
    return Impersonation
  }
  return {
    validate: validateImpersonation,
    build: buildImpersonation
  }
})()

module.exports = Impersonation
